import {CourseAccessQueryParam} from '@/features/course-access/constants';

const SIGNUP_POPUP_PATH = '/join/signup-popup/';

export interface BuildSignupPopupUrlParams {
    /** Current locale in `language_REGION` form (e.g. `en_US`). */
    locale: string;
    /** Path the user should return to after authenticating (no query string). */
    nextPath: string;
    /**
     * Password param to preserve on the post-auth redirect. Only included in
     * the `next` URL when a non-empty value is provided; an empty/undefined
     * password leaves the `next` URL without a `password=` param.
     */
    password?: string;
}

/**
 * Builds the monolith signup-popup URL that the limited-access flow redirects
 * logged-out users to. The `next` param is the page the user should return to
 * after authenticating, optionally preserving the `?password=` query so the
 * password the user already typed survives the round-trip.
 */
export function buildSignupPopupUrl({locale, nextPath, password}: BuildSignupPopupUrlParams): string {
    let next = nextPath;
    if (password) {
        const nextParams = new URLSearchParams();
        nextParams.set(CourseAccessQueryParam.PASSWORD, password);
        next = `${nextPath}?${nextParams.toString()}`;
    }

    const params = new URLSearchParams();
    params.set('locale', locale);
    params.set('response_type', 'json');
    params.set('next', next);

    return `${SIGNUP_POPUP_PATH}?${params.toString()}`;
}
